import _ from 'lodash';
import React, { useEffect } from 'react';
import {
  Input,
  Icon,
  Segment,
  Table,
  Pagination,
  Grid,
  Button,
} from 'semantic-ui-react';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../app/stores/store';
import ReportsModal from '../TableReports/ReportsModal';
import { Link } from 'react-router-dom';
import DashboardReceivingDeliveryForm from '../Dashboard/SubForms/DashboardReceivingDeliveryForm';
import DeleteConfirmation from '../../app/common/modals/DeleteConfirmation';
import reactStringReplace from 'react-string-replace';
import VaultMasterForm from '../VaultMaster/VaultMasterForm';
import ShelfRackMasterForm from '../ShelfRackMaster/ShelfRackMasterForm';
import DeviceMasterForm from '../DeviceMaster/DeviceMasterForm';
import DepartmentMasterForm from '../DepartmentMaster/DepartmentMasterForm';
import CustomerMasterForm from '../CustomerMaster/CustomerMasterForm';
import WorkLevelMasterForm from '../WorkLevelMaster/WorkLevelMasterForm';
import '../../app/common/MediaQuery/responsive-table-style.css';
import DynamicTableCSVReport from './DynamicTableCSVReport';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
//import { userLanguage } from "../../app/common/userLanguageSchema/userLanguage";

interface Props {
  data: any;
  name: any;
  actiontype: string;
  loading?: boolean;
}
/* Sort - End*/
function DynamicDeliveryTable({ data, name, actiontype, loading }: Props) {
  const {
    dashboardStore,
    receivingdeliveryStore,
    modalStore,
    vaultStore,
    ShelfRackStore,
    DeviceStore,
    departmentStore,
    customerStore,
    WorkLevelStore,
    commonStore,
    userStore: { user },
    DeliveryStore: { hfcDeliveryMetadata },
  } = useStore();
  const { loadVault } = vaultStore;
  const tableName = name;
  // localStorage.setItem(
  // tableName,
  // "isGoing,isHost"
  // );
  let tableHeads: any;
  if (
    localStorage.getItem(tableName) !== undefined &&
    localStorage.getItem(tableName) !== null
  ) {
    tableHeads = localStorage.getItem(tableName)!.split(',');
  } else {
    localStorage.setItem(tableName, '');
  }
  // const tableHeads = tableHead;
  //data.map((i:any) => str.map((j) => delete i[j]));
  /* Sort - Start*/
  function exampleReducer(state: any, action: any) {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column) {
          return {
            ...state,
            tabledata: state.tabledata.slice().reverse(),
            direction:
              state.direction === 'ascending' ? 'descending' : 'ascending',
          };
        }
        return {
          column: action.column,
          tabledata: _.sortBy(state.tabledata, [action.column]),
          direction: 'ascending',
        };
      case 'UPDATE_DATA':
        return {
          column: action.column,
          tabledata: data,
          direction: null,
        };
      default:
        throw new Error();
    }
  }
  const [state, dispatch] = React.useReducer(exampleReducer, {
    column: null,
    tabledata: data,
    direction: null,
  });
  const { column, tabledata, direction } = state;

  useEffect(() => {
    // dipatch is called after data is updated via props
    dispatch({ type: 'UPDATE_DATA' });
  }, [data]);

  /*Code for Button - Start*/
  /*Code for Button - Start*/
  /*Code for Pagination - Start*/
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [postsPerPage] = useState<any>(tableName === 'ReportsTable' ? 10 : 5);
  const [activeRowId, setActiveRowId] = useState<any>(
    dashboardStore.dashboard.rowIdForDynamicTable,
  );
  const [hoverRowId, setHoverRowId] = useState<any>(-1);

  /* Code for Pagination - End*/
  /* Search - Start */
  const [filterObj, setFilterObj] = useState<any>([]);
  const searchFunc = (event: any, data: any) => {
    /*Code for Pagination - Start*/
    setCurrentPage(1);
    /* Code for Pagination - End*/
    if (data.value.toString() !== '') {
      setFilterObj([
        ...filterObj.filter(
          (o: any) => o.key.toString() !== data.name.toString(),
        ),
        {
          key: data.name.toString(),
          filterValue: data.value.toString(),
        },
      ]);
    } else {
      setFilterObj(
        filterObj.filter((o: any) => o.key.toString() !== data.name.toString()),
      );
    }
  };
  function filterFunc(obj: any) {
    const result = filterObj.map((fc: any) =>
      obj[fc.key]
        ? obj[fc.key]
            .toLowerCase()
            .toString()
            .includes(fc.filterValue.toLowerCase().toString())
        : null,
    );
    if (result.filter((e: any) => e === false).length === 0) return true;
    return false;
  }
  /* Search - End */
  const handleChange = () => {
    if (tableName === 'ReportsTable') {
      dashboardStore.setTableClicked(
        tabledata.length > 0
          ? [
              'title',
              'type',
              'element',
              'asset_tracking_status',
              'physical_sensor_qrcode',
              'physical_sensor_barcode',
              'originindia',
              'year',
              'language',
            ]
          : null,
        tableName,
      );
      dashboardStore.reportsConfigurationOpen(true);
    } else {
      dashboardStore.setTableClicked(
        tabledata.length > 0 ? Object?.keys(tabledata[0]) : null,
        tableName,
      );
      dashboardStore.reportsConfigurationOpen(true);
    }
  };
  /////////////// Edit Function (Receving Delivery )
  const loadEditData = (id: string) => {
    if (tableName === 'ReceivingTable') {
      modalStore.openModal(<DashboardReceivingDeliveryForm />);
      receivingdeliveryStore.loadReceivingDelivery(id);
    } else if (tableName === 'VaultTable') {
      loadVault(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<VaultMasterForm viewPort={false} />);
    } else if (tableName === 'ShelfRackTable') {
      ShelfRackStore.loadshelfRack(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<ShelfRackMasterForm viewPort={false} />);
    } else if (tableName === 'DeviceTable') {
      DeviceStore.loadDevice(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<DeviceMasterForm />);
    } else if (tableName === 'DepartmentTable') {
      departmentStore.loadDepartment(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<DepartmentMasterForm isEdit />);
    } else if (tableName === 'CustomerTable') {
      customerStore.loadCustomer(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<CustomerMasterForm />);
    } else if (tableName === 'WorkLevelTable') {
      WorkLevelStore.loadWorkLevel(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<WorkLevelMasterForm />);
    } else {
      console.log('clicked');
    }
  };
  //////////////delete the receving delivery,Customer,Dept,Shelf ,Vault Device item group
  const deleteData = (data: any, type: string) => {
    modalStore.openModal(
      <DeleteConfirmation type={type} name={data.title} data={data} />,
    );
  };
  //////// function to get clicked value
  const getClickedValue = (rowData: any, tableName: string) => {
    if (tableName === 'ReceivingTable') {
      dashboardStore.showClickedValueForReceiving(
        rowData.id,
        rowData.receivingTitle,
        rowData.barcode_Package,
      );
    } else if (tableName === 'OrderRegisterTable') {
      dashboardStore.dashboard.deliveryOrderTableClicked = true;
      dashboardStore.setOrderRequestDetails(rowData);
    } else if (tableName === 'AssetTable') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    } else if (
      tableName === 'DeliveryTableSmall' ||
      tableName === 'DeliveryTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.itemId);
      if (
        commonStore.hfcCustomerChanges &&
        dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Delivery'
      ) {
        hfcDeliveryMetadata({ itemId: rowData.itemId });
      }
    } else if (
      tableName === 'OutwardsTableSmall' ||
      tableName === 'OutwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'InwardsTableSmall' ||
      tableName === 'InwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (tableName === 'AssetTableTag' || tableName === 'TagTable') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    }
    setActiveRowId(rowData.id);
  };

  let tableheightcss =
    tableName === 'ReceivingTable' ||
    tableName === 'AssetTableTag' ||
    tableName === 'OrderRegisterTable' ||
    tableName === 'TagTable' ||
    tableName === 'DeliveryTableSmall' ||
    tableName === 'InwardsTableSmall' ||
    tableName === 'OutwardsTableSmall' ||
    tableName === 'VaultTable' ||
    tableName === 'EmailTable' ||
    tableName === 'DeviceTable' ||
    tableName === 'ShelfRackTable' ||
    tableName === 'DepartmentTable' ||
    tableName === 'WorkLevelTable' ||
    tableName === 'HistoryTable' ||
    tableName === 'OrderTable' ||
    tableName === 'AlertsTable';

  const classNameFunc1 = (data: string) => {
    if (data === 'ReportsTable') {
      return 'table-height-reports';
    } else if (tableheightcss) {
      return 'table-height'; //small table
    } else {
      return 'table-height1';
    }
  };

  const classNameFunc2 = (data: string) => {
    if (data === 'ReportsTable') {
      return 'dynamictableoverflow-reports';
    } else if (tableheightcss) {
      return 'dynamictableoverflow';
    } else {
      return 'dynamictableoverflow1';
    }
  };

  return (
    <>
      {window.innerWidth > 768 ? (
        <Segment className={classNameFunc1(tableName)}>
          <Segment className={classNameFunc2(tableName)}>
            {/* {mediaAssetStore.mediaAsset.resolveValueSelected&& <MediaAssetResolveModal/>} */}
            {dashboardStore.dashboard.reportsConfiguration === true ? (
              <ReportsModal
                toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
              />
            ) : null}
            <Table
              sortable
              selectable
              celled
              singleLine
              padded={
                tableheightcss || tableName === 'ReportsTable' ? 'very' : false
              }
            >
              <Table.Header>
                <Table.Row>
                  {tabledata?.length > 0 ? (
                    Object?.keys(tabledata[0])?.includes('title') ? (
                      <Table.HeaderCell>
                        <Input
                          style={{
                            minWidth: '200px',
                          }}
                          name={'title'}
                          fluid
                          loading={loading}
                          icon={!loading ? 'search' : ''}
                          placeholder={
                            (
                              userLanguage[0]
                                .DynamicTableSearchPlaceHolderTitleAlone
                                .DTSTHPT01 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Search..."
                          //"Search..."//Inventory Tag, Create Order, Reports[New Assets titles, digitization priority], Production Planning[L2 & L3]: Title alone
                          onChange={searchFunc}
                        />
                      </Table.HeaderCell>
                    ) : null
                  ) : null}

                  {tableHeads?.map((i: any, index: number) =>
                    i.toLowerCase() !== 'id' ? (
                      i.toLowerCase() !== 'title' &&
                      i.toLowerCase() !== 'calculated category' ? (
                        <Table.HeaderCell key={index + 'tableHead'}>
                          <Input
                            style={{
                              minWidth: '100px',
                            }}
                            name={i}
                            fluid
                            loading={loading}
                            icon={!loading ? 'search' : ''}
                            placeholder={
                              (
                                userLanguage[0]
                                  .DynamicTableSearchPlaceHolderExceptTitle
                                  .DTSTHPET01 as any
                              )?.[`${commonStore.language.key}`]
                            } //"Search..."
                            //Tables: DeliveryTableBig,DeliveryTableSmall, OrderRegister, Tag [all headers except title], Receiving Create Order[all headers except title],
                            //Reports(New Assets titles[all headers except title], digitization priority[all headers except title]), Orders all tables(Outwards, Inwards, Reports)
                            //Production planning (L2 & L3[all headers except title])
                            //View Tables: Vault, Device, ShelfRack, Department, Alerts
                            onChange={searchFunc}
                          />
                        </Table.HeaderCell>
                      ) : null
                    ) : null,
                  )}
                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  actiontype !== 'priority' ? (
                    <Table.HeaderCell> </Table.HeaderCell>
                  ) : null}

                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>

              <Table.Header>
                <Table.Row>
                  {tabledata?.length > 0 ? (
                    Object.keys(tabledata[0]).includes('title') ? (
                      <Table.HeaderCell
                        sorted={column === 'title' ? direction : null}
                        // onClick={() =>
                        //   dispatch({ type: "CHANGE_SORT", column: "title" })
                        // }
                      >
                        Title
                      </Table.HeaderCell>
                    ) : null
                  ) : null}
                  {tableHeads.length > 0
                    ? // You have an array
                      tableHeads.map((i: any, index: number) =>
                        i !== 'id' ? (
                          i.toLowerCase() !== 'title' ? (
                            <Table.HeaderCell
                              key={index + 'tableHead'}
                              sorted={column === '{i}' ? direction : null}
                              // onClick={() =>
                              //   dispatch({ type: "CHANGE_SORT", column: "{i}" })
                              // }
                            >
                              {reactStringReplace(
                                (
                                  i.charAt(0).toUpperCase() +
                                  i.slice(1).split('_').join(' ')
                                )
                                  .split(' ')
                                  .map(
                                    (i: any) =>
                                      i.charAt(0).toUpperCase() +
                                      i.slice(1) +
                                      ' ',
                                  ),
                                /([A-Z])/,
                                (m: any) => ' ' + m,
                              )}
                            </Table.HeaderCell>
                          ) : null
                        ) : null,
                      )
                    : {}}

                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  actiontype !== 'priority' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>
              <Table.Body className="tabletexttruncate">
                {tabledata
                  .filter(filterFunc)
                  .slice(
                    parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                      parseInt(postsPerPage, 10),
                    parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                  ).length !== 0 ? (
                  tabledata
                    .filter(filterFunc)
                    .slice(
                      parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                        parseInt(postsPerPage, 10),
                      parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                    )
                    .map((rowData: any) => (
                      <Table.Row
                        key={rowData['id']}
                        active={rowData['id'] === activeRowId}
                        onClick={() => getClickedValue(rowData, tableName)}
                        onMouseOver={() => setHoverRowId(rowData['id'])}
                      >
                        {/* {tableName === "AssetTable" ||
                    Object.keys(tabledata[0]).includes("title") ? (
                      <Table.Cell key={rowData["id"]}>
                           {
                          tableName === "AlertsTable" ? (
                            <Link to={`/mediaAssets/${rowData["itemID"]}`}>{rowData["title"]}</Link>
                          ) : tableName === "WorkLevelTable" ? (
                            rowData["title"]
                          ) : (
                            <Link to={`/mediaAssets/${rowData["id"]}`}>{rowData["title"]}</Link>
                          )
                        }

                       
                      </Table.Cell>
                    ) : null} */}
                        {tableHeads.map((i: any) =>
                          i !== 'id' ? (
                            i !== 'assetName' ? (
                              i.toLowerCase() === 'parent' ? (
                                <Table.Cell key={i}>
                                  <Link
                                    to={`/mediaAssets/${rowData[
                                      'parent'
                                    ]?.split('/')[0]}`}
                                  >
                                    {rowData['parent']?.split('/')[1]}
                                  </Link>
                                </Table.Cell>
                              ) : (
                                <>
                                  {user?.customerName === 'LVP CMS - AM' ? (
                                    <>
                                      {i.toLowerCase() ===
                                        'physical_location_vault' ||
                                      i.toLowerCase() === 'asset_In_Vault' ? (
                                        <></>
                                      ) : i.toLowerCase() ===
                                        'physical_location_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`physical_location_vault`]}
                                        </Table.Cell>
                                      ) : i.toLowerCase() ===
                                        'asset_in_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`asset_In_Vault`]}
                                        </Table.Cell>
                                      ) : (
                                        <Table.Cell key={i}>
                                          {rowData[i]}
                                        </Table.Cell>
                                      )}
                                    </>
                                  ) : (
                                    <Table.Cell key={i}>
                                      {rowData[i]}
                                    </Table.Cell>
                                  )}
                                </>
                              )
                            ) : (
                              <Table.Cell key={rowData['id']}>
                                <Link to={`/mediaAssets/${rowData['itemId']}`}>
                                  {rowData['assetName']}
                                </Link>
                              </Table.Cell>
                            )
                          ) : null,
                        )}
                        {actiontype === 'button' ? (
                          <Table.Cell collapsing>
                            {rowData['id'] === hoverRowId ? (
                              <Button.Group compact size="tiny">
                                <Button positive>Approve</Button>
                                <Button.Or />
                                <Button>Deny</Button>
                              </Button.Group>
                            ) : null}
                          </Table.Cell>
                        ) : null}
                        {actiontype !== 'editdel' &&
                        actiontype !== 'Resolve' &&
                        actiontype !== 'priority' &&
                        actiontype.length > 0 ? (
                          <Table.Cell collapsing>
                            <Button.Group
                              compact
                              size="tiny"
                              style={{
                                visibility:
                                  rowData['id'] === hoverRowId
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            >
                              <Button
                                positive
                                onClick={() =>
                                  dashboardStore.DenialModalOpen(
                                    true,
                                    actiontype.split('|')[0],
                                    true,
                                    rowData.itemId,
                                  )
                                }
                              >
                                {actiontype.split('|')[0]}
                              </Button>

                              {actiontype.split('|')[1] && (
                                <>
                                  <Button.Or />
                                  <Button
                                    onClick={() =>
                                      dashboardStore.DenialModalOpen(
                                        true,
                                        actiontype.split('|')[1],
                                        false,
                                        rowData.itemId,
                                      )
                                    }
                                    size="tiny"
                                  >
                                    {actiontype.split('|')[1]}
                                    {/* Denied */}
                                  </Button>
                                </>
                              )}
                            </Button.Group>
                          </Table.Cell>
                        ) : null}

                        {actiontype === 'editdel' ? (
                          <Table.Cell collapsing style={{ width: '5vw' }}>
                            {rowData['id'] === hoverRowId ? (
                              <>
                                <Icon
                                  name="edit"
                                  disabled={
                                    tableName === 'VaultTable' &&
                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      'VMVVB02',
                                    )
                                      ? true
                                      : tableName === 'DeviceTable' &&
                                          !dashboardStore.dashboard.selectedUserRoleId.includes(
                                            'DMVDB02',
                                          )
                                        ? true
                                        : tableName === 'ShelfRackTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'SRMVB02',
                                            )
                                          ? true
                                          : tableName === 'DepartmentTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'DMVB02',
                                              )
                                            ? true
                                            : tableName === 'CustomerTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'CMVB02',
                                                )
                                              ? true
                                              : tableName ===
                                                    'WorkLevelTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'AVIB02',
                                                  )
                                                ? true
                                                : false
                                  }
                                  onClick={() => loadEditData(rowData.id)}
                                />
                                <Icon
                                  disabled={
                                    tableName === 'VaultTable' &&
                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      'VMVVB03',
                                    )
                                      ? true
                                      : tableName === 'DeviceTable' &&
                                          !dashboardStore.dashboard.selectedUserRoleId.includes(
                                            'DMVDB03',
                                          )
                                        ? true
                                        : tableName === 'ShelfRackTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'SRMVB03',
                                            )
                                          ? true
                                          : tableName === 'DepartmentTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'DMVB03',
                                              )
                                            ? true
                                            : tableName === 'CustomerTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'CMVB03',
                                                )
                                              ? true
                                              : tableName ===
                                                    'WorkLevelTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'AVIB03',
                                                  )
                                                ? true
                                                : false
                                  }
                                  name="delete"
                                  onClick={() => deleteData(rowData, tableName)}
                                />
                              </>
                            ) : null}
                          </Table.Cell>
                        ) : null}
                      </Table.Row>
                    ))
                ) : (
                  <Table.Row
                    style={{
                      height: '20vh',
                      overflow: 'hidden',
                    }}
                  >
                    <Table.Cell
                      colSpan={
                        data.length > 0 ? Object.keys(data[0]).length : 9
                      }
                      collapsing
                    >
                      <p className="tableEmptyData">Sorry, no data to show</p>
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </Segment>
          <Segment raised attached="top">
            <div className="dynamicDeliveryTableFooter">
              <Pagination
                defaultActivePage={1}
                totalPages={Math.ceil(
                  Object.keys(tabledata.filter(filterFunc)).length /
                    postsPerPage,
                )}
                onPageChange={(_event, data) => setCurrentPage(data.activePage)}
              />
              <div>
                <DynamicTableCSVReport
                  tableData={tabledata}
                  tableName={tableName}
                />
                <div>
                  <Icon
                    // onClick={() => dashboardStore.reportsConfigurationOpen(true)}
                    onClick={handleChange}
                    corner="bottom right"
                    size="large"
                    circular
                    inverted
                    color="teal"
                    name="settings"
                  />
                </div>
              </div>
            </div>
          </Segment>
        </Segment>
      ) : (
        <>
          <Segment basic className="dynamictableoverflow-mobile">
            <>
              {dashboardStore.dashboard.reportsConfiguration === true ? (
                <ReportsModal
                  toggleProps={
                    dashboardStore.dashboard.tableconfigurationClicked
                  }
                />
              ) : null}
              <Table sortable selectable celled singleLine padded="very">
                <Table.Header>
                  <Table.Row>
                    {tabledata?.length > 0 ? (
                      Object?.keys(tabledata[0])?.includes('title') ? (
                        <Table.HeaderCell>
                          <Input
                            style={{
                              minWidth: '200px',
                            }}
                            name={'title'}
                            fluid
                            loading={loading}
                            icon={!loading ? 'search' : ''}
                            placeholder={
                              (
                                userLanguage[0]
                                  .InventoryReportsDynamicTableSearchPlaceHolder
                                  .IRDTSTHP01 as any
                              )?.[`${commonStore.language.key}`]
                            } //"Search..."
                            //not used // Inventory L3 tables 2,3,4,5
                            onChange={searchFunc}
                          />
                        </Table.HeaderCell>
                      ) : null
                    ) : null}

                    {tableHeads.map((i: any, index: number) =>
                      i.toLowerCase() !== 'id' ? (
                        i.toLowerCase() !== 'title' &&
                        i.toLowerCase() !== 'calculated category' ? (
                          <Table.HeaderCell key={index + 'tableHead'}>
                            <Input
                              style={{
                                minWidth: '100px',
                              }}
                              name={i}
                              fluid
                              loading={loading}
                              icon={!loading ? 'search' : ''}
                              placeholder={
                                (
                                  userLanguage[0]
                                    .InventoryReportsDynamicTableSearchPlaceHolder
                                    .IRDTSTHP01 as any
                                )?.[`${commonStore.language.key}`]
                              } //"Search..."
                              //not used // Inventory L3 tables 2,3,4,5
                              onChange={searchFunc}
                            />
                          </Table.HeaderCell>
                        ) : null
                      ) : null,
                    )}
                    {actiontype !== 'Resolve' &&
                    actiontype !== 'editdel' &&
                    actiontype !== '' &&
                    actiontype !== 'priority' ? (
                      <Table.HeaderCell></Table.HeaderCell>
                    ) : null}

                    {actiontype === 'editdel' ? (
                      <Table.HeaderCell></Table.HeaderCell>
                    ) : null}
                  </Table.Row>
                </Table.Header>

                <Table.Header>
                  <Table.Row>
                    {tabledata.length > 0 ? (
                      Object.keys(tabledata[0]).includes('title') ? (
                        <Table.HeaderCell
                          sorted={column === 'title' ? direction : null}
                          //  onClick={() =>
                          //    dispatch({ type: "CHANGE_SORT", column: "title" })
                          //  }
                        >
                          Title
                        </Table.HeaderCell>
                      ) : null
                    ) : null}
                    {tableHeads.length > 0
                      ? // You have an array
                        tableHeads.map((i: any, index: number) =>
                          i !== 'id' ? (
                            i.toLowerCase() !== 'title' ? (
                              <Table.HeaderCell
                                key={index + 'tableHead'}
                                sorted={column === '{i}' ? direction : null}
                                //  onClick={() =>
                                //    dispatch({ type: "CHANGE_SORT", column: "{i}" })
                                //  }
                              >
                                {reactStringReplace(
                                  (
                                    i.charAt(0).toUpperCase() +
                                    i.slice(1).split('_').join(' ')
                                  )
                                    .split(' ')
                                    .map(
                                      (i: any) =>
                                        i.charAt(0).toUpperCase() +
                                        i.slice(1) +
                                        ' ',
                                    ),
                                  /([A-Z])/,
                                  (m: any) => ' ' + m,
                                )}
                              </Table.HeaderCell>
                            ) : null
                          ) : null,
                        )
                      : {}}
                    {actiontype === 'Resolve' ? (
                      <Table.HeaderCell></Table.HeaderCell>
                    ) : null}
                    {actiontype !== 'Resolve' &&
                    actiontype !== 'editdel' &&
                    actiontype !== '' &&
                    actiontype !== 'priority' ? (
                      <Table.HeaderCell></Table.HeaderCell>
                    ) : null}
                    {actiontype === 'editdel' ? (
                      <Table.HeaderCell></Table.HeaderCell>
                    ) : null}
                  </Table.Row>
                </Table.Header>
                <Table.Body className="tabletexttruncate">
                  {tabledata
                    .filter(filterFunc)
                    .slice(
                      parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                        parseInt(postsPerPage, 10),
                      parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                    ).length !== 0 ? (
                    tabledata
                      .filter(filterFunc)
                      .slice(
                        parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                          parseInt(postsPerPage, 10),
                        parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                      )
                      .map((rowData: any) => (
                        <Table.Row
                          key={rowData['id']}
                          active={rowData['id'] === activeRowId}
                          onClick={() => getClickedValue(rowData, tableName)}
                          onMouseOver={() => setHoverRowId(rowData['id'])}
                        >
                          {tableName === 'AssetTable' ||
                          Object.keys(tabledata[0]).includes('title') ? (
                            <Table.Cell key={rowData['id']}>
                              {tableName !== 'WorkLevelTable' ? (
                                <Link to={`/mediaAssets/${rowData['id']}`}>
                                  {rowData['title']}
                                </Link>
                              ) : (
                                rowData['title']
                              )}
                            </Table.Cell>
                          ) : null}
                          {tableHeads.map((i: any) =>
                            i !== 'id' ? (
                              i.toLowerCase() !== 'title' &&
                              i.toLowerCase() !== 'parent' ? (
                                <>
                                  {user?.customerName === 'LVP CMS - AM' ? (
                                    <>
                                      {i.toLowerCase() ===
                                        'physical_location_vault' ||
                                      i.toLowerCase() === 'asset_In_Vault' ? (
                                        <></>
                                      ) : i.toLowerCase() ===
                                        'physical_location_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`physical_location_vault`]}
                                        </Table.Cell>
                                      ) : i.toLowerCase() ===
                                        'asset_in_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`asset_In_Vault`]}
                                        </Table.Cell>
                                      ) : (
                                        <Table.Cell key={i}>
                                          {rowData[i]}
                                        </Table.Cell>
                                      )}
                                    </>
                                  ) : (
                                    <Table.Cell key={i}>
                                      {rowData[i]}
                                    </Table.Cell>
                                  )}
                                </>
                              ) : i.toLowerCase() === 'parent' ? (
                                <Table.Cell key={i}>
                                  <Link
                                    to={`/mediaAssets/${rowData[
                                      'parent'
                                    ]?.split('/')[0]}`}
                                  >
                                    {rowData['parent']?.split('/')[1]}
                                  </Link>
                                </Table.Cell>
                              ) : null
                            ) : null,
                          )}
                          {actiontype === 'button' ? (
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <Button.Group compact size="tiny">
                                  <Button positive>Approve</Button>
                                  <Button.Or />
                                  <Button>Deny</Button>
                                </Button.Group>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                          {/* {actiontype !== "editdel" &&
                       actiontype !== "Resolve" &&
                       actiontype !== "priority" &&
                       actiontype.length > 0 ? (
                         <Table.Cell collapsing>
                           {rowData["id"] === hoverRowId ? (
                             <Button.Group compact size="tiny">
                               <Button
                                 positive
                                 onClick={() =>
                                   dashboardStore.DenialModalOpen(
                                     true,
                                     actiontype.split("|")[0],
                                     true,
                                     rowData.itemId
                                   )
                                 }
                               >
                                 {actiontype.split("|")[0]}
                               </Button>
   
                               {actiontype.split("|")[1] && (
                                 <>
                                   <Button.Or />
                                   <Button
                                     onClick={() =>
                                       dashboardStore.DenialModalOpen(
                                         true,
                                         actiontype.split("|")[1],
                                         false,
                                         rowData.itemId
                                       )
                                     }
                                     size="tiny"
                                   >
                                     {actiontype.split("|")[1]}
                                   </Button>
                                 </>
                               )}
                             </Button.Group>
                           ) : null}
                         </Table.Cell>
                       ) : null} */}

                          {actiontype === 'editdel' ? (
                            <Table.Cell
                              collapsing
                              style={{
                                width: '5vw',
                              }}
                            >
                              {rowData['id'] === hoverRowId ? (
                                <>
                                  <Icon
                                    name="edit"
                                    disabled={
                                      tableName === 'VaultTable' &&
                                      !dashboardStore.dashboard.selectedUserRoleId.includes(
                                        'VMVVB02',
                                      )
                                        ? true
                                        : tableName === 'DeviceTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'DMVDB02',
                                            )
                                          ? true
                                          : tableName === 'ShelfRackTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'SRMVB02',
                                              )
                                            ? true
                                            : tableName === 'DepartmentTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'DMVB02',
                                                )
                                              ? true
                                              : tableName === 'CustomerTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'CMVB02',
                                                  )
                                                ? true
                                                : tableName ===
                                                      'WorkLevelTable' &&
                                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                      'AVIB02',
                                                    )
                                                  ? true
                                                  : false
                                    }
                                    onClick={() => loadEditData(rowData.id)}
                                  />
                                  <Icon
                                    disabled={
                                      tableName === 'VaultTable' &&
                                      !dashboardStore.dashboard.selectedUserRoleId.includes(
                                        'VMVVB03',
                                      )
                                        ? true
                                        : tableName === 'DeviceTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'DMVDB03',
                                            )
                                          ? true
                                          : tableName === 'ShelfRackTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'SRMVB03',
                                              )
                                            ? true
                                            : tableName === 'DepartmentTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'DMVB03',
                                                )
                                              ? true
                                              : tableName === 'CustomerTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'CMVB03',
                                                  )
                                                ? true
                                                : tableName ===
                                                      'WorkLevelTable' &&
                                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                      'AVIB03',
                                                    )
                                                  ? true
                                                  : false
                                    }
                                    name="delete"
                                    onClick={() =>
                                      deleteData(rowData, tableName)
                                    }
                                  />
                                </>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                        </Table.Row>
                      ))
                  ) : (
                    <Table.Row
                      style={{
                        height: '20vh',
                        overflow: 'hidden',
                      }}
                    >
                      <Table.Cell
                        colSpan={
                          data.length > 0 ? Object.keys(data[0]).length : 9
                        }
                        collapsing
                      >
                        <p className="tableEmptyData">Sorry, no data to show</p>
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            </>
          </Segment>
          <Grid columns="3">
            <Pagination
              //  style={{marginRight: "62px"}}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              pointing
              secondary
              totalPages={Math.ceil(
                Object.keys(tabledata.filter(filterFunc)).length / postsPerPage,
              )}
              onPageChange={(event, data) => setCurrentPage(data.activePage)}
            />
            <Grid.Column width={1}>
              <DynamicTableCSVReport
                tableData={tabledata}
                tableName={tableName}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Icon
                onClick={handleChange}
                corner="bottom right"
                size="large"
                circular
                inverted
                color="teal"
                name="settings"
              />
            </Grid.Column>
          </Grid>
        </>
      )}
    </>
  );
}
export default observer(DynamicDeliveryTable);
